import React from 'react';

import { css } from '@emotion/css';
import { Card, CardContent, CardHeader, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles';
import { LanguageSelector } from '@/uiKit/molecules/LanguageSelector.tsx';

export type LanguageProps = {
  className?: string;
};

export const Language: React.FC<LanguageProps> = ({ className }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <Card id="language-selection-card" className={className} elevation={0}>
      <CardHeader
        id="language-title"
        title={t('pages.account.language.title')}
        onClick={() => {
          throw new Error('This is your first error!');
        }}
      />
      <CardContent>
        <LanguageSelector
          id="language-selection-button"
          className={styles.language}
          display="full"
        />
      </CardContent>
    </Card>
  );
};

const makeStyles = (theme: Theme) => ({
  infoDisplay: css`
    column-gap: ${theme.spacing(12)};
  `,
  language: css({
    width: 'fit-content',
  }),
});
